import UserGradeStatus from "@/dictionary/UserGradeStatus";
import BaseModel from "./BaseModel";

/**
 * UserGrade
 */
export default class UserGrade extends BaseModel{
  maxAttempts = 1;

  constructor({
    id,
    lesson,
    correct,
    givenAnswer,
    status,
    user,
    attempts,
    created_at,
    updated_at,
    deleted_at
  }) {
    super();
    
    this.id = id || null;
    this.lesson = lesson || null;
    this.correct = correct == 1 ? true : false;
    this.givenAnswer = givenAnswer || null;
    this.status = parseInt(status) || null;
    this.user = user || null;
    this.attempts = attempts || 0;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;

    this.userGradeStatus = new UserGradeStatus();
  }

  /**
   * Checks if this UserGrade has any attempts left
   * @returns {boolean}
   */
  hasAttempts() {
    return this.attempts >= this.maxAttempts ? false : true;
  }

  /**
   * Returns if UserGrade 'correct' attr is true
   * @returns {boolean}
   */
  isCorrect() {
    return this.correct ? true : false;
  }

  /**
   * Returns if UserGrade has a givenAnswer
   * @returns {boolean}
   */
  hasAnswer () {
    return this.givenAnswer != null ? true : false;
  }

  /**
   * Checks if UserGrade was answered by its status
   * @returns {bool}
   */
  isAnswered() {
    return this.status == this.userGradeStatus.ANSWERED;
  }
}